import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";
import { ReviewableAction, useActionContext, useCommentContext } from "../../../providers";
import { memo } from "react";

const CommentBoxHeader = () => {
    const { submitComments } = useCommentContext();
    const { reset } = useActionContext();

    const handleClose = () => {
        reset(ReviewableAction.Comment);
        submitComments();
    };

    return (
        <Box
            sx={{
                position: 'relative',
                padding: 2,
                textAlign: 'center',
                fontWeight: 'bold'
            }}
        >
            Request changes / Write comments
            <IconButton
                onClick={handleClose}
                sx={{
                    m: 1,
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: 1,
                }}
            >
                <Close />
            </IconButton>
        </Box>
    );
};

export default memo(CommentBoxHeader);
